export function normalizeInvite(input: string): string {
    let value = input.trim();

    value = value.replace(/^https?:\/\//i, "");

    const inviteMatch = value.match(/\/invite\/([^/?#]+)/i);
    if (inviteMatch) return inviteMatch[1];

    if (value.includes("/")) {
        value = value.split("/").pop() ?? value;
    }

    return value.split("?")[0].split("#")[0];
}
